<nb-card [formGroup]="diaForm">
  <nb-card-header>
    <h6 class="text-heading">
      {{ title }}
    </h6>
  </nb-card-header>
  <nb-card-body>
    <div class="form-group">
      <textarea
        nbInput
        fullWidth
        rows="5"
        id="inputReason"
        placeholder="Nhập lý do"
        class="form-control"
        formControlName="reason"
        [(ngModel)]="reason"
      ></textarea>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton outline status="info" (click)="cancel()">Từ Chối</button>
    <button
      nbButton
      hero
      status="primary"
      (click)="submit()"
      [disabled]="submitted || !diaForm.valid"
      [class.btn-pulse]="submitted"
    >
      Đồng Ý
    </button>
  </nb-card-footer>
</nb-card>
